if (!customElements.get('ampd-sticky-atc')) {
  class AmpdStickyAtc extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product') || this.closest('.shopify-section');
      this.productInfo = this.productSection ? this.productSection.querySelector('.product-info') : null;
      this.productForm = this.productSection ? this.productSection.querySelector('product-form') : null;

      if (this.productSection && 'IntersectionObserver' in window) {
        this.bindEvents();
        this.bindFormState();
        this.updateBodyState();
      }
    }

    disconnectedCallback() {
      if (this.scrollHandler) window.removeEventListener('scroll', this.scrollHandler);
      if (this.observer) this.observer.disconnect();
    }

    bindEvents() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            // Mobile: only show once the add-to-cart form is scrolled above the viewport.
            this.classList.toggle('ampd-sticky-atc--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            // Desktop: show once the (sticky) product info column has been scrolled past.
            this.classList.toggle('ampd-sticky-atc--out', entry.isIntersecting);
          }
        });
        this.updateBodyState();
      });

      if (this.productForm) this.observer.observe(this.productForm);
      if (this.productInfo) this.observer.observe(this.productInfo);

      this.scrollHandler = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
    }

    /**
     * Hides the bar when scrolled to the very bottom of the page (footer).
     */
    handleScroll() {
      this.classList.toggle(
        'ampd-sticky-atc--page-end',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
      this.updateBodyState();
    }

    /**
     * Mirrors the bar's visible/hidden state onto a <body> class, so other
     * fixed-position widgets (e.g. the chat bubble) can shift out of the bar's
     * way via CSS and shift back when it hides — reliably, without :has().
     */
    updateBodyState() {
      var visible =
        !this.classList.contains('ampd-sticky-atc--out') &&
        !this.classList.contains('ampd-sticky-atc--page-end');
      document.body.classList.toggle('ampd-sticky-atc-visible', visible);

      // Publish the bar's real height so the floating chat widgets can lift
      // by exactly the right amount. Hard-coded offsets go stale the moment
      // the bar gains a line (finance text, a badge), which is how the chat
      // bubble ends up sitting on top of the Add to Cart button.
      var h = Math.round(this.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--ampd-sticky-atc-h', h + 'px');
    }

    /**
     * Mirrors the main product form's busy state onto the bar's button.
     */
    bindFormState() {
      const btn = this.querySelector('.ampd-sticky-atc__btn[form]');
      if (!btn) return;

      const form = document.getElementById(btn.getAttribute('form'));
      if (!form) return;

      const setBusy = (busy) => {
        const currentBtn = this.querySelector('.ampd-sticky-atc__btn');
        if (currentBtn) currentBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
      };

      form.addEventListener('submit', () => {
        setBusy(true);
        // Safety net in case no cart event fires.
        setTimeout(() => setBusy(false), 8000);
      });

      const productForm = form.closest('product-form') || this.productForm;
      if (productForm) {
        productForm.addEventListener('on:cart:add', () => setBusy(false));
        productForm.addEventListener('on:cart:error', () => setBusy(false));
      }
    }
  }

  customElements.define('ampd-sticky-atc', AmpdStickyAtc);
}
